import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TbLoaderQuarter } from 'react-icons/tb';
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import { Autocomplete, Box, Tab, TextField, Switch, Tooltip, debounce } from '@mui/material';
import { observer } from 'mobx-react';
import arm from '../../../assets/robotArm.png';
import electro from '../../../assets/electronics-top-icon.png';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import AllInboxSharpIcon from '@mui/icons-material/AllInboxSharp';
import Pagination from 'base/ui/components/Pagination/pagination';
import { PAGE_SIZE_DEFAULT, URL_HOME, URL_PRINT } from 'utils/constants';
import * as rootStore from 'stores/root_store';
import { useForm } from 'react-hook-form';
import { EquipmentStatusSearch, ListKeynValue, orderIndexByEquipsModels } from 'services/report_services';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Link } from 'react-router-dom';
import { ROUTES } from 'base/routes/routes';
import Dragula from 'react-dragula';
import EditIcon from '@mui/icons-material/Edit';
import { PagePermissionModel, User } from 'services/user_services';
import './machineStatusStyle.css';
import { toast } from 'react-toastify';
import { TiArrowUnsorted } from 'react-icons/ti';
import { AiFillCaretDown, AiOutlineDownload, AiOutlineMinus } from 'react-icons/ai';
import { FaSearch, FaSort, FaSortDown, FaSortUp } from 'react-icons/fa';
import { FiPrinter } from 'react-icons/fi';
import { Button, Radio, RadioChangeEvent, Spin } from 'antd';
import SearchCollapse from '../reportComponents/searchCollapse';
import CustomSelect from 'base/ui/components/CustomSelect';
import { formatNumber } from 'utils/formatHelper';
import { RoutingModel } from 'services/routing_services';
import { checkPermission } from 'utils/permissionHelper';
const Style = {
  '.MuiOutlinedInput-root': {
    padding: 0,
    borderRadius: 0,
  },
  '.css-13xfq8m-MuiTabPanel-root': {
    padding: '5px !important',
  },
  '.css-tqw3aj .css-13xfq8m-MuiTabPanel-root': {
    padding: 5,
  },
  '.MuiOutlinedInput-input': {
    fontSize: '11px',
  },
  '.MuiInputBase-input': {
    fontSize: '13px !important',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
  '.MuiChip-labelMedium': {
    fontSize: '11px',
    padding: '3px',
    fontWeight: '600',
  },
};

export const StatusColor = {
  CM: 'Canh máy',
  HD: 'Hoạt động',
  VS: 'Vệ sinh',
  NM: 'Ngưng máy',
  ET: 'Trống',
};

export const StatusColorTable = [
  { name: 'Hoạt động', value: 'bg-green-500' },
  { name: 'Canh máy/chuẩn bị chuyền', value: 'bg-[#FEF5AC]' },
  { name: 'Vệ sinh', value: 'bg-[#C1EFFF]' },
  { name: 'Ngưng máy', value: 'bg-[#FFB3B3]' },
  { name: 'Trống', value: 'bg-white' },
]

type dataPopUpModel = {
  equipCardId: string;
  barcodeName: string;
  actived?: boolean;
};

export function createMachineStatus() {
  return observer(() => {
    const columnName = [
      {
        columnName: 'STT',
        align: 'text-center',
        style: '',
        visible: true,
        key: 'stt',
      },
      {
        columnName: 'In barcode',
        align: '',
        style: '',
        visible: true,
        key: 'button',
      },
      {
        columnName: 'Tên barcode máy/chuyền',
        align: '',
        style: '',
        visible: true,
        key: 'equipmentName',
        isSoft: true,
      },
      {
        columnName: 'Công Đoạn',
        align: '',
        style: '',
        visible: true,
        key: 'stepCode',
        isSoft: true,
      },
      {
        columnName: 'Phân xưởng',
        align: '',
        style: '',
        visible: true,
        key: 'workShopName',
        isSoft: true,
      },

      {
        columnName: 'Phân loại',
        align: '',
        style: '',
        visible: true,
        key: 'type',
        isSoft: true,
      },
      {
        columnName: 'SL CN',
        align: '',
        style: '',
        visible: true,
        key: 'numberWorker',
        isSoft: true,
      },
      {
        columnName: 'LSX đang thực hiện',
        align: '',
        style: '',
        visible: true,
        key: 'workOrderCode',
        isSoft: true,
      },
      {
        columnName: 'Mã TP/BTP',
        align: '',
        style: '',
        visible: true,
        key: 'productCode',
        isSoft: true,
      },
      {
        columnName: 'Tên TP/BTP',
        align: '',
        style: '',
        visible: true,
        key: 'productName',
        isSoft: true,
      },
      {
        columnName: 'Thời gian bắt đầu',
        align: '',
        style: '',
        visible: true,
        key: 'hourStart',
        isSoft: true,
      },
      // {
      //   columnName: 'TG kết thúc dự kiến',
      //   align: '',
      //   style: '',
      //   visible: true,
      //   key: 'hourEnd',
      // },

      {
        columnName: 'Trạng thái',
        align: '',
        style: '',
        visible: true,
        key: 'status',
      },
      {
        columnName: 'Tình trạng sử dụng',
        align: '',
        visible: true,
        key: 'tinhTrangSuDung',
      },
    ];

    //=======================================================================
    //======================================================================= REGISTER ZONE
    //=======================================================================

    //loading page when reload
    const [isLoading, setIsLoading] = useState(true);
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<EquipmentStatusSearch>();

    // các row trong table lấy từ store
    const tableRows = rootStore.reportStore.equipmentStatus.data;
    //các row trong sơ đồ
    const diagramRows = rootStore.reportStore.WorkShopEquipmentsStatus.data;

    //======================================================================= For search ZONE
    // list workshop danh sách phân xưởng
    const [listWS, setListWS] = useState<ListKeynValue[]>([]);
    // list status danh sach trang thai
    const [listStatus, setListStatus] = useState<ListKeynValue[]>([]);
    // list status danh sach trang thai
    const [listGE, setListGE] = useState<ListKeynValue[]>([]);
    // danh sách tên máy
    const [listEN, setListEN] = useState<ListKeynValue[]>([]);

    // =======================================================TÌM KIẾM ========================================================
    // sort
    const [orderByDesc, setOrderByDesc] = useState<string | undefined>();
    const [orderBy, setOrderBy] = useState<string | undefined>();

    //--------------------------------------------- PARAM TÌM KIẾM ------------------------------------------------
    //thong tin hien thi tren search
    const [listENS, setListENS] = useState<string[]>([]);
    // tìm kiếm theo status
    const [statusKey, setStatusKey] = useState<string | null>(null);
    //tìm theo nhóm máy
    const [groupEq, setGroupEq] = useState<string[]>([]);
    // tim kiem theo phan xuong
    const [wSId, setWSId] = useState<string | null>(null);
    // hàm handle change value của tình trạng sử dụng trong search
    const [valueStatusSearch, setValueStatusSearch] = useState<boolean | undefined>(true);
    // List dropdown routing
    const [listRouting, setListRouting] = useState<RoutingModel[]>([]);

    // tìm kiếm công đoạn
    const [dataRouting, setDataRouting] = useState<string[]>([])

    // =======================================================XXXXXX ========================================================

    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageIndex: 1,
        pageSize: PAGE_SIZE_DEFAULT,
      },
      workShopId: undefined as string | undefined | null,
      machineGroup: [] as string[] | undefined,
      machineStatus: undefined as string | undefined | null,
      equipmentList: [] as string[] | undefined,
      actived: true as boolean | undefined,
      steps: [] as string[],
    });

    // value of tab index
    const [value, setValue] = React.useState('1');

    const [inputValue, setInputValue] = useState<dataPopUpModel>({
      equipCardId: '',
      barcodeName: '',
      actived: false,
    });

    // OPEN POP UP DIALOG
    const [open, setOpen] = React.useState(false);
    const data = JSON.parse(localStorage.getItem('user_session') || '{}') as User;

    //=======================================================================
    //=======================================================================HANDLE ZONE
    //=======================================================================

    //KIỂM TRA PHÂN QUYỀN, NẾU THUỘC PHÂN QUYỀN CHO PHÉP SỬA MỚI CÓ THỂ SỬA THÔNG TIN

    const pagePermit = data.webPermission?.pagePermissionModel;
    const [checkPermitRename, setCheckermitRename] = useState(false);

    const [allowOrder, setAllowOrder] = useState(false);

    // KIỂM TRA CÁC QUYỀN KHI LOAD TRANG
    const handleCheckPermit = () => {
      pagePermit.map((item: PagePermissionModel) => {
        if (item.functionId === 'RENAME') setCheckermitRename(true);
        if (item.functionId === 'UPDATE_ORDER_INDEX') setAllowOrder(true);
      });
    };

    // THAY ĐỔI SỐ LƯỢNG TRANG
    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      getequipmentStatus({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: 1, pageSize: parseInt(e.target.value) },
      });
    };

    // THAY ĐỔI TRANG
    const handleChangePageIndex = (data: any) => {
      getequipmentStatus({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: data.selected + 1 },
      });
    };

    //=======================================================================HANDLE ZONE FOR SEARCH
    const getWSE = async () => {
      await rootStore.reportPresenter.WorkShopEquipments(
        rootStore.reportStore,
        dataSearch.workShopId,
        dataSearch.machineGroup,
        dataSearch.machineStatus,
        dataSearch.equipmentList,
        dataSearch.actived,
      );

      // );
    };

    // FOR SEARCH : CẬP NHẬT THAY ĐỔI PHÂN XƯỞNG
    const handleChangeWorkShopName = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setWSId(option.key);
        await getListGE([option.key]);
        getListEN(option.key);
      } else {
        setWSId(null);
        await getListGE();
        getListEN('');
      }
    };

    //  FOR SEARCH : CẬP NHẬT THAY ĐỔI TRẠNG THÁI
    const handleChangeStatus = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setStatusKey(option.key);
      } else {
        setStatusKey(null);
      }
    };

    // FOR SEARCH : CẬP NHẬT THAY ĐỔI NHÓM MÁY MÓC
    const handleChangeGroupEquip = (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && Array.isArray(option)) {
        setGroupEq(
          option.map((item) => {
            return item.key;
          }),
        );
      } else {
        setGroupEq([]);
      }
    };

    const handleChangeEN = (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && Array.isArray(option)) {
        setListENS(
          option.map((item) => {
            return item.key;
          }),
        );
      } else {
        setListENS([]);
      }
    };

    // FOR SEARCH : HÀM THỰC HIỆN QUÁ TRÌNH TÌM KIẾM
    const onSearch = async () => {
      setIsLoading(true);
      // lưu lại các trường đã search
      setDataSearch({
        paging: {
          ...dataSearch.paging,
          pageIndex: 1,
        },
        workShopId: wSId,
        machineGroup: groupEq,
        machineStatus: statusKey,
        equipmentList: listENS,
        actived: valueStatusSearch,
        steps: dataRouting
      });
      await rootStore.reportPresenter.getEquipmentStatusReport(rootStore.reportStore, {
        paging: {
          pageIndex: 1,
          pageSize: dataSearch.paging.pageSize,
        },
        workShopId: wSId,
        machineGroup: groupEq,
        machineStatus: statusKey,
        equipmentList: listENS,
        actived: valueStatusSearch,
        steps: dataRouting
      });

      await rootStore.reportPresenter.WorkShopEquipments(
        rootStore.reportStore,
        wSId,
        groupEq,
        statusKey,
        listENS,
        valueStatusSearch,
      );

      setIsLoading(false);
    };

    // HÀM GỌI LẠI SAU 6S
    const handleReload = async () => {
      setIsLoading(true);

      // await rootStore.reportPresenter.getEquipmentStatusReport(rootStore.reportStore, dataSearch);

      await rootStore.reportPresenter.WorkShopEquipments(
        rootStore.reportStore,
        wSId,
        groupEq,
        statusKey,
        listENS,
        valueStatusSearch,
      );
      // setPageIndex();
      setIsLoading(false);
    };

    const [autoLoad, setAutoLoad] = useState(true);
    // HÀM XỬ LÝ QUÁ TRÌNH TỰ ĐỘNG TẢI LẠI API
    const handleAutoLoad = async () => {
      setAutoLoad(!autoLoad);
    };
    useEffect(() => {
      let inter: any;
      if (autoLoad === true)
        inter = setInterval(() => {
          handleReload();
        }, 60000);
      return () => {
        clearInterval(inter);
      };
    }, [autoLoad, wSId, groupEq, statusKey]);

    //=======================================================================HANDLE ZONE FOR SƠ ĐỒ
    // THAY ĐỔI TAB TỪ BẢNG SANG SƠ ĐỒ
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue);
    };

    const [checkPermitOrder, setCheckPermitOrder] = useState(false);
    // HÀM XỬ LÝ CHỌN / KHÔNG CHỌN THAY ĐỔI VỊ TRÍ
    const handleCheckPermitChangePosition = async () => {
      await rootStore.reportPresenter.WorkShopEquipments(
        rootStore.reportStore,
        wSId,
        groupEq,
        statusKey,
        listENS,
        valueStatusSearch,
      );
      setCheckPermitOrder(!checkPermitOrder);
    };

    // HÀM THỰC HIỆN THAY ĐỔI VỊ TRÍ TRONG SƠ ĐỒ
    let dragEvent: any = null;
    let tempt: orderIndexByEquipsModels = { orderIndexByEquips: [] };

    const dragulaDecorator = async (componentBackingInstance: any) => {
      if (componentBackingInstance) {
        let options = {};
        dragEvent = Dragula([componentBackingInstance], options);
      }

      dragEvent.on('drop', (el: any, target: any) => {
        var div_list = target.querySelectorAll('.insideDiagram');
        tempt = { orderIndexByEquips: [] };
        Array.from(div_list).forEach((el: any, idex) => {
          tempt.orderIndexByEquips.push({
            equipCardId: el.id,
            orderIndex: idex,
          });
        });
        saveChangeIndex(tempt);
      });

      const saveChangeIndex = async (tempt1: any) => {
        await rootStore.reportPresenter.updateIndexBarcode(rootStore.reportStore, tempt1);
      };
    };

    // ref của button in
    const ref = useRef<HTMLFormElement>(null);
    // tham số truyền vào param
    const [dataParam, setDataParam] = useState({
      equipmentId: '',
      stepCode: '',
      workShopId: ''
    });
    // Hàm in barcode cho từng row
    const handlePrintBarcode = async (equipmentId: string, stepCode: string, workShopId: string) => {
      setDataParam({
        equipmentId: equipmentId,
        stepCode: stepCode,
        workShopId: workShopId
      });
      setTimeout(() => {
        // Form Post data submit in *form modal*
        ref.current?.submit();
      }, 100);
    };

    const dataByBarcode = rootStore.reportStore.ListEquipmentOfBarCode.data;
    // MỞ CỬA SỐ POP UP SỬA TÊN
    const handleClickOpen = async (id: string, value: string, actived?: boolean) => {
      setInputValue({ ...inputValue, equipCardId: id, barcodeName: value, actived: actived });
      setValueStatus(actived);
      await rootStore.reportPresenter.getListEquipmentOfBarCode(rootStore.reportStore, id);
      setOpen(true);
    };

    // ĐÓNG CỬA SỐ POP UP SỬA TÊN
    const handleClose = () => {
      setOpen(false);
    };

    // LƯU THAY ĐỔI TÊN SAU KHI SỬA
    const handleSaveForm = async () => {
      await rootStore.reportPresenter.updateBarCodeNameEquip(rootStore.reportStore, inputValue);
      if (rootStore.reportStore.UpdateResponse.isSuccess) {
        toast.success(rootStore.reportStore.UpdateResponse.message);

        await rootStore.reportPresenter.getEquipmentStatusReport(rootStore.reportStore, dataSearch);
      }
      handleClose();
    };
    //=======================================================================
    //=======================================================================USEEFFECT ZONE
    //=======================================================================

    const getequipmentStatus = async (data: any, key?: string) => {
      setIsLoading(true);

      // setIsLoading(true);
      if (!orderBy && !orderByDesc) {
        setOrderBy(key);
        setOrderByDesc(undefined);
        Object.assign(data.paging, { orderBy: key });
      } else if (orderBy === key) {
        setOrderBy(undefined);
        setOrderByDesc(key);
        Object.assign(data.paging, { orderByDesc: key });
      } else if (orderByDesc === key) {
        setOrderBy(undefined);
        setOrderByDesc(undefined);
      } else {
        setOrderBy(key);
        setOrderByDesc(undefined);
        Object.assign(data.paging, { orderBy: key });
      }
      setDataSearch(data);

      await rootStore.reportPresenter.getEquipmentStatusReport(rootStore.reportStore, data);
      setIsLoading(false);
    };

    // =======================================================================================================
    // ===========================================DATA CÁC DROPDOWN=================================================
    // =======================================================================================================
    const getListWSName = async () => {
      await rootStore.reportPresenter.getListWorkShop(rootStore.reportStore);
      setListWS(rootStore.reportStore.listKeynValue.data);
    };
    // call data dropdown nhóm trạng thái thiết bị
    const getListEquipStatus = async () => {
      await rootStore.reportPresenter.getListEquipmentStatus(rootStore.reportStore);
      setListStatus(rootStore.reportStore.listKeynValue.data);
    };
    // call data dropdown nhóm máy
    const getListGE = async (phanXuong?: string[]) => {
      await rootStore.reportPresenter.getListGroupEquip(rootStore.reportStore, phanXuong ? phanXuong : []);
      setListGE(rootStore.reportStore.listKeynValue.data);
    };
    // call data dropdown tên Máy
    const getListEN = async (key: string) => {
      await rootStore.reportPresenter.getListDropdownEquipmentName(rootStore.reportStore, key);
      setListEN(rootStore.reportStore.listKeynValue.data);
    };

    // Call api get list routing
    const getDropDownRouting = async (keyWord: string) => {
      await rootStore.routingPresenter.getListRouting(rootStore.routingStore, keyWord);
      setListRouting(rootStore.routingStore.routing.data);
    };

    const searchRouting = useCallback(debounce(getDropDownRouting, 300), [])

    useEffect(() => {
      getListEN('');
      getListGE();
      getListWSName();
      getListEquipStatus();
      handleCheckPermit();
      getWSE();
      getequipmentStatus(dataSearch);
      getDropDownRouting('')
    }, []);
    // =============================================================================================================
    // =============================================================================================================

    // hàm handle change value của tình trạng sử dụng trong pop up
    const [valueStatus, setValueStatus] = useState<boolean | undefined>(false);
    const onChangeStatus = (e: RadioChangeEvent, type?: string) => {
      if (type === 'search') {
        setValueStatusSearch(e.target.value);
      } else {
        setValueStatus(e.target.value);
        setInputValue({ ...inputValue, actived: e.target.value });
      }
    };

    const hasExport = checkPermission('EXPORT')

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================
    return (
      <div className="w-full py-3 px-5 ">
        <SearchCollapse title="BC01. Tình trạng máy móc tại nhà máy"
          extra={hasExport && <Button
            size="middle"
            loading={isLoading}
            className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
            onClick={async () => {
              setIsLoading(true);
              await rootStore.reportPresenter.exportExcelBC01({
                ...dataSearch,
              });
              setIsLoading(false);
            }}
            type="primary"
          >
            <AiOutlineDownload className="block text-base" />
            <span className="block">Export Excel</span>
          </Button>}
        >
          <form onSubmit={handleSubmit(onSearch)} className="w-full p-3.5 lg:grid lg:grid-cols-2 flex flex-col gap-2">

            {/* Công đoạn */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Công đoạn"
                placeholder="Chọn công đoạn..."
                data={listRouting}
                fieldNames={{ label: 'stepName', value: 'stepCode' }}
                onChangeValue={(_, option) => {
                  if (option && Array.isArray(option)) {
                    setDataRouting(
                      option.map((item) => {
                        return item.stepCode;
                      }),
                    );
                  } else {
                    setDataRouting([]);
                  }
                }}
                idKey="steps"
                onSearch={(value) => {
                  searchRouting(value);
                }}
                showSearch
                allowClear
                filterOption={false}
              />
            </div>
            {/* Chọn phân xưởng */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Phân xưởng"
                placeholder="--Tất cả--"
                data={listWS}
                onChangeValue={handleChangeWorkShopName}
                idKey="listWS"
                showSearch
                allowClear
              />
            </div>

            {/* Chọn trạng thái */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Trạng thái"
                placeholder="--Tất cả--"
                data={listStatus}
                onChangeValue={handleChangeStatus}
                idKey="listStatus"
                showSearch
                allowClear
              />
            </div>

            {/* Chọn Nhóm máy */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Nhóm máy"
                placeholder="Chọn nhóm máy..."
                data={listGE}
                onChangeValue={handleChangeGroupEquip}
                idKey="listGE"
                showSearch
                allowClear
                filterOption={true}
              />
            </div>

            {/* Chọn Tên máy */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <CustomSelect
                mode="multiple"
                title="Tên máy"
                placeholder="Chọn tên máy..."
                data={listEN}
                onChangeValue={handleChangeEN}
                idKey="listEN"
                showSearch
                allowClear
                filterOption
              />
            </div>

            {/* Tình trạng sử dụng */}
            <div className="w-full sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-black sm:text-end">Tình trạng sử dụng</label>
              <Radio.Group
                className="col-span-2 !ml-5"
                onChange={(e) => onChangeStatus(e, 'search')}
                value={valueStatusSearch}
              >
                <Radio value={true}>Đang sử dụng</Radio>
                <Radio value={false}>Ngưng sử dụng</Radio>
              </Radio.Group>
            </div>

            {/* button tìm kiếm */}
            <div className="w-full flex justify-center col-span-2">
              <button
                type="submit"
                onClick={handleSubmit(onSearch)}
                className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 mt-1 text-center focus:outline-none hover:bg-blue-600 ${isLoading && 'bg-blue-400'
                  }`}
              >
                {isLoading ? (
                  <>
                    <TbLoaderQuarter className="animate-spin bg" />
                    Loading...
                  </>
                ) : (
                  <>
                    <FaSearch className="font-bold" />
                    &nbsp; Tìm kiếm
                  </>
                )}
              </button>
            </div>
          </form>
        </SearchCollapse>

        <Box sx={Style} className="bg-white w-full rounded-sm border border-neutral-300">
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Danh Sách" value="1" />
                <Tab label={`Sơ đồ mặt bằng phân xưởng`} value="2" />
              </TabList>
            </Box>


            <TabPanel value="1">
              <div className="w-full bg-white py-3 px-1 rounded">

                {/* bảng chú thích */}
                <table
                  width={300}
                  className="h-fit bg-white text-default table-auto space-collapse"
                >
                  <thead className="text-white !bg-[#1677ff]">
                    <tr>
                      <th
                        className="font-semibold border border-border_input"
                      >
                        Màu sắc
                      </th>
                      <th
                        className="font-semibold border border-border_input"
                      >
                        Trạng thái máy
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {StatusColorTable.map((item) => {
                      return (
                        <tr key={item.name}>
                          <td
                            className={`px-2 border border-border_input ${item.value}`}
                            width={100}
                          >
                          </td>
                          <td
                            className={"border border-border_input px-2"}
                          >
                            {item.name}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {/*=========== Pagination =======================*/}
                <Pagination
                  pageCount={rootStore.reportStore.equipmentStatus.pagesCount}
                  forcePage={dataSearch.paging.pageIndex - 1}
                  onPageSizeChange={handleChangePageSize}
                  onPageChange={handleChangePageIndex}
                />
                {/* =========== Table PO ===============*/}
                <div className={`overflow-x-auto my-3 overflow-y-auto max-h-[800px]`}>
                  <Spin spinning={isLoading}>
                    <table className="w-full text-default table-auto border mb-2 ">
                      <thead className="font-bold text-white bg-[#4682B4] sticky top-0 ">
                        <tr>
                          {columnName?.map((item, index) => {
                            if (item.visible) {
                              return (
                                <th
                                  key={index}
                                  scope="col"
                                  onClick={() =>
                                    index > 1 &&
                                    index !== 12 &&
                                    getequipmentStatus(
                                      {
                                        ...dataSearch,
                                        paging: {
                                          pageIndex: dataSearch.paging.pageIndex,
                                          pageSize: dataSearch.paging.pageSize,
                                        },
                                        // workShopId: wSId,
                                        // machineGroup: groupEq,
                                        // machineStatus: statusKey,
                                        // equipmentList: listENS,
                                        // actived: valueStatusSearch,
                                      },
                                      item.key,
                                    )
                                  }
                                  className={`${item.visible ? '' : 'hidden'} ${item.style
                                    } p-1 border border-collapse cursor-pointer !text-[13px] font-[550] py-2 items-center text-start
                            `}
                                >
                                  {item.isSoft ? (
                                    <div className=" flex gap-1 justify-between items-center cursor-pointer">
                                      <span className="text-start">{`${item.columnName}`}</span>
                                      <span>
                                        {orderBy === item.key ? (
                                          <FaSortDown />
                                        ) : orderByDesc === item.key ? (
                                          <FaSortUp />
                                        ) : (
                                          <FaSort />
                                        )}
                                      </span>
                                    </div>
                                  ) : (
                                    `${item.columnName}`
                                  )}
                                </th>
                              );
                            }
                          })}
                        </tr>
                      </thead>
                      <tbody>
                        {(tableRows?.length as Number) ? (
                          tableRows?.map((item, index) => {
                            return (
                              <tr
                                key={index}
                                className={`
                            ${item.status === StatusColor.HD ? 'bg-green-500' : ''}
                            ${item.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                            ${item.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                            ${item.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                            ${item.status === StatusColor.ET ? 'bg-white' : ''}
                            text-[13px] text-black  font-[400]  whitespace-nowrap`}
                              >
                                {/* stt */}
                                <td className="p-1 border text-center">{item.stt}</td>
                                {/* nút lưu barcode (in barcode) */}
                                <td className="p-1 border text-center">
                                  <form
                                    className="flex justify-center"
                                    ref={ref}
                                    method="POST"
                                    action={`${URL_HOME}/Reports/ReportEquipment/Index/?${dataParam.equipmentId ? `EquipmentId=${dataParam.equipmentId}&` : ''
                                      }${dataParam.stepCode ? `StepCode=${dataParam.stepCode}` : ''}${dataParam.workShopId ? "&&workShop=" + dataParam.workShopId : ""}`}
                                    target={'_blank'}
                                  >
                                    {dataSearch.actived ? (
                                      <button type="submit">
                                        <FiPrinter
                                          className="cursor-pointer"
                                          onClick={() => handlePrintBarcode(item.equipmentId, item.stepCode, item.workShopId)}
                                        />
                                      </button>
                                    ) : (
                                      ''
                                    )}
                                  </form>
                                </td>
                                {/* Tên máy */}
                                <td
                                  className={`p-1 border whitespace-normal min-w-[200px] ${checkPermitRename === false ? '' : 'flex'
                                    }`}
                                >
                                  <span className={`${checkPermitRename === false ? '' : 'flex-1'}`}>
                                    {item.equipmentName}
                                  </span>
                                  {checkPermitRename && (
                                    <span
                                      onClick={() =>
                                        handleClickOpen(
                                          item.id,
                                          item.equipmentName !== null ? item.equipmentName : '',
                                          item.actived,
                                        )
                                      }
                                      className="shrink-0 cursor-pointer"
                                    >
                                      <EditIcon className="!text-xs" />
                                    </span>
                                  )}
                                </td>
                                {/* Công đoạn */}
                                <td className="p-1 border">
                                  {item.stepCode}-{item.stepName}
                                </td>
                                {/* phân xưởng */}
                                <td className="p-1 border">{item.workShopName}</td>
                                {/* Phân loại */}
                                <td className="p-1 border">{item.type}</td>
                                {/* SL CN */}
                                <td className="p-1 border text-right">{formatNumber(item.numberWorker, 0)}</td>
                                {/* LSX đang thực hiện */}
                                <td className="p-1 border">{item.workOrderCode}</td>
                                {/* Mã TP/BTP */}
                                <td className="p-1 border">{item.productCode}</td>
                                {/* Tên TP/BTP */}
                                <td className="p-1 border !max-w-[200px] whitespace-nowrap truncate">
                                  <Tooltip title={`${item.productName}`}>
                                    <span>{item.productName}</span>
                                  </Tooltip>
                                </td>
                                {/* thời gian bắt đầu */}
                                <td className="p-1 border text-center">{item.hourStart}</td>
                                {/* thời gian kết thúc dự kiến */}
                                {/* <td className="p-1 border text-center">{item.hourEnd}</td> */}
                                {/* Trạng thái */}
                                <td className="p-1 border">{item.status}</td>
                                {/* Tình trạng sử dụng */}
                                <td className="p-1 border">{item.actived ? 'Đang sử dụng' : 'Ngưng sử dụng'}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="border whitespace-nowrap p-1.5 text-default text-center" colSpan={100}>
                              Không tìm thấy dòng nào phù hợp
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </Spin>
                </div>
                {/*=========== Pagination =======================*/}
                <Pagination
                  hiddenPageSize
                  pageCount={rootStore.reportStore.equipmentStatus.pagesCount}
                  forcePage={dataSearch.paging.pageIndex - 1}
                  onPageSizeChange={handleChangePageSize}
                  onPageChange={handleChangePageIndex}
                />
                <span className="block text-default">
                  Đang xem từ {`${tableRows && tableRows.length ? tableRows[0]?.stt : 0}`} đến {`${tableRows && tableRows.length ? tableRows[tableRows.length - 1]?.stt : 0}`} trong tổng số{' '}
                  {`${rootStore.reportStore.equipmentStatus.recordsTotal || 0}`} mục
                </span>
              </div>
            </TabPanel>
            <TabPanel value="2">
              {/* xem toan man hinh */}
              <div className="grid grid-cols-5 gap-10 text-default">
                <Link
                  to={ROUTES.REPORTS.MACHINE_STATUS.SUB_LINK + `${wSId !== null ? '?workShopId=' + wSId : ''}`}
                  target="_blank"
                  className="text-center col-span-3"
                >
                  <h2 className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                    Xem toàn màn hình <QueuePlayNextIcon />
                  </h2>
                </Link>
                {allowOrder && (
                  <div className="flex justify-center items-center border">
                    <span>Đổi vị trí</span>
                    <Switch
                      size="small"
                      className="!text-[45px] text-center"
                      defaultChecked={false}
                      onChange={handleCheckPermitChangePosition}
                    />
                  </div>
                )}
                <div className="flex justify-center items-center border">
                  <span>Tự cập nhật</span>
                  <Switch
                    size="small"
                    className="!text-[45px] text-center"
                    defaultChecked={true}
                    onChange={handleAutoLoad}
                  />
                </div>
              </div>
              <div className="flex items-center justify-center flex-col">
                {diagramRows.length ? (
                  diagramRows.map((item, index) => {
                    return (
                      <div key={index} className="w-full mt-5">
                        <div className="p-3 border-b-2 border-black text-white bg-[#4682B4]">
                          <h2 className="text-default font-bold ">{item.workShopName}</h2>
                        </div>
                        {/* ======================================================================== */}
                        {checkPermitOrder === true && (
                          <div
                            ref={dragulaDecorator}
                            className="grid grid-cols-2` sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 coverDiagram"
                          >
                            {item.workShopEquipments.map((it, id) => {
                              return (
                                <div
                                  id={it.id}
                                  key={id}
                                  className={`
                                ${it.status === StatusColor.HD ? 'bg-green-500' : ''}
                            ${it.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                            ${it.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                            ${it.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                            ${it.status === StatusColor.ET ? 'bg-white' : ''}
                                col-span-1 p-3 rounded-2xl m-2 text-default font-semibold  cursor-move insideDiagram shadow-md shadow-gray-800/80 `}
                                >
                                  <Link
                                    className="cursor-move"
                                    to={ROUTES.REPORTS.REPORT_KHSX.DETAILS_LINK + `/` + it.id}
                                  >
                                    <div className="text-xs">
                                      <div>
                                        <div>
                                          <h1 className="font-bold text-center min-h-[30px] cursor-pointer hover:text-blue-500">
                                            {it.equipmentName}
                                          </h1>
                                        </div>

                                        <div className=" pb-1 flex gap-3 items-center justify-center border-b border-black border-dashed my-1">
                                          <img
                                            className=" text-black"
                                            width={60}
                                            src={it.type?.startsWith('C') ? electro : arm}
                                            alt="Phan Loai"
                                          />
                                          <span>{it.status}</span>
                                        </div>
                                      </div>
                                      <div>
                                        <DescriptionIcon />
                                        <span>{it.kssxNumber}</span>
                                      </div>
                                      <div className="flex">
                                        <AllInboxSharpIcon className="mb-2" />
                                        <div>
                                          <div>{it.productCode}</div>
                                          <div>{it.productName}</div>
                                        </div>
                                      </div>
                                      <div>
                                        <PersonIcon />
                                        <span>
                                          {it.numberWorker && it.numberWorker >= 1 ? it.numberWorker + ' người' : ''}
                                        </span>
                                      </div>
                                      <div>
                                        <AccessTimeFilledIcon />
                                        <span>
                                          {it.hourStart} {it.hourEnd ? ' đến ' : ''} {it.hourEnd}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="text-xs">
                                      <div className="border-b-[3px] border-black  border-dashed my-1"></div>
                                      <div>
                                        {it.nextWorkOrder &&
                                          it.nextWorkOrder.split(',').map((s, index) => (
                                            <div key={index}>
                                              <span>{s}</span>
                                              <br />
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        {/* ======================================================================== */}
                        {checkPermitOrder === false && (
                          <div
                            //ref={dragulaDecorator}
                            className="grid grid-cols-2` sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 coverDiagram"
                          >
                            {item.workShopEquipments.map((it, id) => {
                              return (
                                <div
                                  id={it.id}
                                  key={id}
                                  className={`
                              ${it.status === StatusColor.HD ? 'bg-green-500' : ''}
                          ${it.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                          ${it.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                          ${it.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                          ${it.status === StatusColor.ET ? 'bg-white' : ''}
                              col-span-1 p-3 rounded-2xl m-2 text-default font-semibold insideDiagram shadow-md shadow-gray-800/80 `}
                                >
                                  <Link to={ROUTES.REPORTS.REPORT_KHSX.DETAILS_LINK + `/` + it.id}>
                                    <div className="text-xs">
                                      <div>
                                        <h1 className="font-bold text-center min-h-[30px] cursor-pointer hover:text-blue-500 ">
                                          {it.equipmentName}
                                        </h1>

                                        <div className=" pb-1 flex gap-3 items-center justify-center border-b border-black border-dashed my-1">
                                          <img
                                            className=" text-black"
                                            width={60}
                                            src={it.type?.startsWith('C') ? electro : arm}
                                            alt="Phan Loai"
                                          />
                                          <span>{it.status}</span>
                                        </div>
                                      </div>
                                      <div>
                                        <DescriptionIcon />
                                        <span>{it.kssxNumber}</span>
                                      </div>
                                      <div className="flex">
                                        <AllInboxSharpIcon className="mb-2" />
                                        <div>
                                          <div>{it.productCode}</div>
                                          <Tooltip title={it.productName}>
                                            <div className="lg:w-[150px] lg:truncate xl:w-[150px] xl:truncate">
                                              {it.productName}
                                            </div>
                                          </Tooltip>
                                        </div>
                                      </div>
                                      <div>
                                        <PersonIcon />
                                        <span>
                                          {it.numberWorker && it.numberWorker >= 1 ? it.numberWorker + ' người' : ''}
                                        </span>
                                      </div>
                                      <div>
                                        <AccessTimeFilledIcon />
                                        <span>
                                          {it.hourStart} {it.hourEnd ? ' đến ' : ''} {it.hourEnd}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="text-xs">
                                      <div className="border-b-[3px] border-black  border-dashed my-1"></div>
                                      <div>
                                        {it.nextWorkOrder &&
                                          it.nextWorkOrder.split(',').map((s, index) => (
                                            <div key={index}>
                                              <span>{s}</span>
                                              <br />
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              );
                            })}
                          </div>
                        )}
                        <hr />
                      </div>
                    );
                  })
                ) : (
                  <div>
                    <div className="w-full mt-2 border whitespace-nowrap p-1.5 text-default text-center">
                      Không tìm thấy dữ liệu
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
          </TabContext>
        </Box>

        {/* POP UP */}
        <div className={`w-full h-screen fixed bg-modal inset-0 z-[100] ${!open && 'hidden'}`}>
          <div className="fixed w-auto min-w-[400px] bg-white top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 shadow-xl p-5 shadow-modal text-default rounded border-t-2 border-t-sky-700">
            <div className="text-center">
              <h2 className="text-base font-bold mb-2 uppercase bg-slate-200">Đổi tên barcode máy/chuyền</h2>
              <label htmlFor="name" className="w-full block text-default font-semibold text-left text-blue-700">
                Tên barcode máy/chuyền
              </label>
              <TextField
                value={inputValue.barcodeName}
                onChange={(e) => {
                  setInputValue({ ...inputValue, barcodeName: e.target.value });
                }}
                className="w-full text-[12px]"
                autoFocus={true}
                id="name"
                placeholder="Nhập tên muốn thay đổi"
                type="text"
                variant="standard"
              />
              {/* Tình trạng sử dụng */}
              <div className="flex items-center mt-2 gap-2">
                <label className="font-bold">Tình trạng sử dụng: </label>
                <Radio.Group onChange={onChangeStatus} value={valueStatus}>
                  <Radio value={true}>Đang sử dụng</Radio>
                  <Radio value={false}>Ngưng sử dụng</Radio>
                </Radio.Group>
              </div>
            </div>
            {dataByBarcode.length > 0 && (
              <table className=" w-full text-center mt-5">
                <thead className="text-white bg-[#4682B4]">
                  <tr className="border">
                    <td className="border p-1">STT</td>
                    <td className="border p-1">Mã máy</td>
                    <td className="border p-1">Tên máy</td>
                  </tr>
                </thead>
                <tbody>
                  {dataByBarcode.map((item, index) => {
                    return (
                      <tr className="border" key={index}>
                        <td className="border p-1">{item.stt}</td>
                        <td className="border p-1">{item.equipmentCode}</td>
                        <td className="border p-1 text-left">{item.equipmentName}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
            <div className="flex justify-between mt-3">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-sm text-white bg-red-400 hover:bg-red-400/90 px-3 py-1 min-w-[80px]"
              >
                Hủy
              </button>
              <button
                type="button"
                onClick={handleSaveForm}
                className={`rounded-sm bg-primary hover:bg-primary/90 px-3 py-1 min-w-[80px] text-white `}
              >
                Xác nhận
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  });
}
